export function ArrowView() {
  return (
    <svg
      width={12}
      height={12}
      className="fill-white dark:fill-black"
      viewBox="0 0 12 12"
    >
      <path d="M0 12 L6 0 L12 12 Z" fill="theme-outline" />

      <line
        x1="0"
        y1="12"
        x2="6"
        y2="0"
        className="stroke-theme-outline stroke-1"
        fill="none"
      />

      <line
        x1="6"
        y1="0"
        x2="12"
        y2="12"
        className="stroke-theme-outline stroke-1"
        fill="none"
      />
    </svg>
  );
}
